import {
  RequestAuthMode,
  RequestAuthTokenSource,
  RequestExecutionMode,
  RouteFamily,
} from '../../types/route';

export const AUTHTOKEN_RESOLVED_REQUEST = {
  authMode: RequestAuthMode.NONE,
  executionMode: RequestExecutionMode.PASSTHROUGH,
  family: RouteFamily.LOCAL,
  logicalPath: 'local:/api/authtoken',
  tokenSource: RequestAuthTokenSource.NONE,
} as const;
